import { combineReducers } from 'redux'
import {
  createReducer,
  createMappedRequestReducer,
  createRequestReducer
} from 'pobble-components/dist/redux-helpers'
import { normalize, schema } from 'normalizr'

const normalizeGroups = groups => {
  const group = new schema.Entity('groups')
  return normalize(groups, [group])
}

const PupilReducer = combineReducers({
  fetching: createMappedRequestReducer('PUPIL_PROFILE_STORE:FETCHING'),
  updating: createMappedRequestReducer('PUPIL_PROFILE_STORE:UPDATE_PUPIL'),
  addingPermission: createRequestReducer('PUPIL_PROFILE_STORE:ADD_PERMISSION'),
  removingPermission: createRequestReducer(
    'PUPIL_PROFILE_STORE:REMOVE_PERMISSION'
  ),
  resettingPasscode: createMappedRequestReducer(
    'PUPIL_PROFILE_STORE:RESET_PASSCODE'
  ),
  removingFromGroup: createMappedRequestReducer(
    'PUPIL_PROFILE_STORE:REMOVE_PUPIL_FROM_GROUP'
  ),
  addingToGroup: createMappedRequestReducer(
    'PUPIL_PROFILE_STORE:ADD_PUPIL_TO_GROUP'
  ),
  profile: createReducer(null, {
    'PUPIL_PROFILE_STORE:FETCHING_REQUEST_SUCCESS': (state, { response }) =>
      response.data.account,
    'PUPIL_PROFILE_STORE:UPDATE_PUPIL_REQUEST_SUCCESS': (state, { response }) =>
      response.data.account,
    'PUPIL_PROFILE_STORE:RESET_PASSCODE_REQUEST_SUCCESS': (
      state,
      { response }
    ) => response.data.account,
    'PUPIL_PROFILE_STORE:ADD_PERMISSION_REQUEST_SUCCESS': state => ({
      ...state,
      student_type: {
        ...state.student_type,
        policy: {
          ...state.student_type.policy,
          can_publish: true
        }
      }
    }),
    'PUPIL_PROFILE_STORE:REMOVE_PERMISSION_REQUEST_SUCCESS': state => ({
      ...state,
      student_type: {
        ...state.student_type,
        policy: {
          ...state.student_type.policy,
          can_publish: false
        }
      }
    }),
    'PUPIL_PROFILE_STORE:REFETCH_POLICY_REQUEST_SUCCESS': (
      state,
      { response }
    ) => ({
      ...state,
      student_type: {
        ...state.student_type,
        policy: response.data.account.student_type.policy
      }
    })
  }),
  groups: createReducer(null, {
    'PUPIL_PROFILE_STORE:FETCHING_REQUEST_SUCCESS': (state, { response }) =>
      normalizeGroups(response.data.account.student_type.groups),
    'PUPIL_PROFILE_STORE:ADD_PUPIL_TO_GROUP_REQUEST_SUCCESS': (
      state,
      { response, params }
    ) => ({
      ...state,
      entities: {
        groups: {
          ...state.entities.groups,
          [response.data.group.id]: response.data.group
        }
      },
      result: [...state.result, response.data.group.id]
    }),
    'PUPIL_PROFILE_STORE:REMOVE_PUPIL_FROM_GROUP_REQUEST_SUCCESS': (
      state,
      { params }
    ) => {
      const groups = { ...state.entities.groups }
      delete groups[params.groupId]
      return {
        entities: {
          groups
        },
        result: state.result.filter(id => id !== params.groupId)
      }
    }
  })
})

export default PupilReducer
